<template>
    <a-modal
            :width="'50%'"
            v-model="isShowAskLeaveModal"
            :title="$t('supervise.absent')"
            destroyOnClose
            @ok="handleOk"
            @cancel="onCancel">
        <div class="page-modal">
            <!-- 未请假状态 -->
            <a-form v-if="!entityInfo.start_time" :form="form">
                <div class="content">
                    <a-form-item :label="$t('supervise.selecteTimeTip')">
                        <a-range-picker
                                style="width:100%"
                                class="picker"
                                :disabledDate="disabledDate"
                                :ranges="{
                                    [$t('global.tomorrow')]: [moment().subtract('days', -1).startOf('day'), moment().subtract('days', -1).endOf('day')],
                                    [$t('global.thisWeek')]: [moment(), moment().endOf('week')],
                                    [$t('global.thisMounth')]: [moment(), moment().endOf('month')]
                                }"
                                showTime
                                format="YYYY/MM/DD HH:mm"
                                @change="onDateChange"
                                v-decorator="[
                                  'timeRange',
                                  {
                                    rules: [{
                                      required: true, message: $t('supervise.selecteTimeTip'),
                                    }]
                                  }
                                ]"
                        />
                    </a-form-item>


                    <div class="info" v-if="false">
                        <a-alert type="success">
                            <div slot="message">
                                距离请假正式生效还有
                                <span class="main">{{moment().to(startTime * 1000, true)}}</span>，请假时长<span class="main">{{moment(startTime * 1000).to(endTime * 1000, true)}}</span>
                            </div>
                        </a-alert>
                    </div>

                    <a-form-item :label="$t('supervise.reason')">
                        <a-textarea v-model="reason" v-decorator="[
                                  'reason',
                                  {
                                    rules: [{
                                      required: true, message: $t('supervise.reason'),
                                    }]
                                  }
                                ]"></a-textarea>
                    </a-form-item>

                    <!-- {{entityInfo}} -->
                </div>
            </a-form>

            <!-- 请假状态下 -->
            <div class="content" v-else>
                <h3>{{$t('supervise.absent')}}:</h3>
                <!-- 显示请假的时间段 -->
                <div>{{moment(entityInfo.start_time * 1000).format('YYYY/MM/DD HH:mm') + '-- ' + moment(entityInfo.end_time * 1000).format('YYYY/MM/DD HH:mm')}}</div>
                <div>{{$t('supervise.reason') + ': ' + entityInfo.description}}</div>
                <!-- 提前结束请假 -->
                <a-popconfirm
                        :title="$t('global.confirm')"
                        @confirm="preLeaveOff()">
                    <a-button style="margin-top:10px" type="primary">{{$t('supervise.preBack')}}</a-button>
                </a-popconfirm>
                <div class="info">
                    <a-alert type="info">
                        <div slot="message">
                            {{$t('supervise.backTip')}}
                        </div>
                    </a-alert>
                </div>
            </div>
        </div>
    </a-modal>
</template>
<script>
    import moment from 'moment'
    import config from '@/config'

    export default {
        props: {
            showAskLeaveModal: {
                type: Boolean,
                required: true
            },
            entityInfo: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                // 是否显示模态框
                isShowAskLeaveModal: this.showAskLeaveModal,
                // 请假开始和结束时间
                startTime: '',
                endTime: '',
                reason: '',
                // 是否选择了请假时间
                hasSelectedDate: false
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        methods: {
            moment,
            // 请假时间只能是未来的时间
            disabledDate(date) {
                return date && date < moment().startOf('day')
            },
            handleOk() {
                // console.log(this.entityInfo.start_time)
                if(this.entityInfo.start_time){
                    this.$emit('quit')
                }else{
                    this.form.validateFieldsAndScroll((err, values) => {
                        if (!err) {
                            let param = {
                                start: this.startTime,
                                end: this.endTime,
                                description: this.reason
                            }
                            this.$http.post(config.api.entity_absent_url + '/' + this.entityInfo.id,param).then((response) => {
                                if(response.code == 0){
                                    // this.$message.success('操作成功')
                                    this.$notification.success({
                                      message: this.$t('global.commitSuccess')
                                    })
                                    this.$emit('success')
                                    this.$emit('quit')
                                } else {
                                    this.$message.error(response.desc)
                                }
                            })
                        }
                    })
                }
            },
            // 点击X或者取消
            onCancel() {
                this.$emit('quit')
            },
            // 当选择的时间改变时触发
            onDateChange(date, dateString) {
                // console.log(date, dateString)
                // 将时间转为时间戳 到 秒
                if (date.length === 2) {
                    // this.startTime = date[0]._d ? Date.parse(date[0]._d) / 1000 : ''
                    this.startTime = moment(date[0]).unix()
                    this.endTime = moment(date[1]).unix()
                    this.hasSelectedDate = true
                } else {
                    // 执行了清空操作
                    // 不能提交
                    this.hasSelectedDate = false
                }
            },
            // 提前销假
            preLeaveOff() {
                this.$http.delete(config.api.entity_absent_url + '/' + this.entityInfo.id).then((response) => {
                    if(response.code == 0){
                        this.$notification.success({
                          message: this.$t('global.commitSuccess')
                        })
                        this.$emit('success')
                        this.$emit('quit')
                    } else {
                        this.$message.error(response.desc)
                    }
                })
            },
        }
    }
</script>
<style lang="less" scoped>
    @import '../../theme/color.less';

    .info {
        margin-top: 10px;
        .main {
            font-size: 1.1rem;
            color: @primary-color;
            // font-weight: 600;
        }
    }
</style>
